import TableHeadItem from './TableHeadItem';

export default TableHeadItem;
